import Vue from "vue"
import Vuex from "vuex"
import common from "./modules/common.js"
import userManage from "./modules/userManage"

Vue.use(Vuex)

export default new Vuex.Store({
  ...common,
  modules: { userManage }
})
